<script setup lang="ts">
withDefaults(defineProps<{ gutter?: boolean }>(), { gutter: true })
</script>
<template>
  <div
    class="relative overflow-hidden rounded-lg bg-white shadow-xs ring-1 ring-zinc-950/5"
    :class="{ 'p-4': gutter }"
  >
    <slot />
  </div>
</template>
